'use client';
import { ImageProps } from '@repo/ui/src/types/image';
import { Data, ProductGridProps } from '@typings/productGrid';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { classNames } from '@repo/ui/src/utils/classNames';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Grid from './_Grid';

export enum GridType {
  Product = 'Product',
  Learn = 'Learn',
  Recipe = 'Recipe',
  TraegerTv = 'Traeger TV',
  Ambassador = 'Ambassador',
  Story = 'Story',
}

interface CategoryGridProps
  extends Pick<
    ProductGridProps,
    'content' | 'showFinancing' | 'hideAddToCartButton' | 'financingText'
  > {
  gridLifestyleCard?: {
    cardIndex: number;
    cardTileWidth: number;
    background: ImageProps;
    toutContent: ToutContentProps;
    horizontalAlignment: string;
    verticalAlignment: string;
  };
  items?: Array<any>;
  nbPages?: number;
  page?: number;
  _data?: Data;
  loadData: (params: { page: number }, controller: AbortController, offset: number) => Promise<any>;
  type: GridType;
  content: any;
  GridItemComponent: any;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  className?: string;
  disableBorder?: boolean;
  darkBackground?: boolean;
}

const CategoryGrid = ({
  gridLifestyleCard,
  items: _items,
  nbPages,
  page: _page,
  _data,
  loadData,
  content,
  GridItemComponent,
  className,
  hideAddToCartButton,
  showFinancing,
  financingText,
  isLoading = false,
  disableBorder = false,
  darkBackground = false,
}: CategoryGridProps) => {
  const [items, setItems] = useState(_items ?? _data?.hits ?? []);
  const [totalPages, setTotalPages] = useState(nbPages ?? _data?.nbPages ?? 0);
  const tmpPage = _page ?? _data?.page;
  const [page, setPage] = useState(tmpPage ? tmpPage + 1 : 1);

  const viewMore = async () => {
    try {
      const controller = new AbortController();
      const res = await loadData({ page }, controller, items.length);

      const { hits = [], nbPages = 0 } = res?.data ?? {};
      setItems((curr) => [...curr, ...hits]);
      setTotalPages(nbPages);
      setPage(page + 1);
    } catch (e) {
      if (!axios.isCancel(e)) {
        console.error(e);
      }
    }
  };

  useEffect(() => {
    if (!_data) return;
    setItems(_data.hits || []);
    setTotalPages(_data.nbPages || 0);
  }, [_data]);

  return (
    <div
      className={classNames(
        'tw-flex tw-flex-col sm:tw-flex-row tw-bg-surface-200',
        darkBackground && 'tw-bg-surface-700',
        className,
      )}
    >
      <Grid
        items={items}
        totalPages={totalPages}
        isLoading={isLoading}
        page={page}
        viewMore={viewMore}
        gridLifestyleCard={gridLifestyleCard}
        content={content}
        GridItemComponent={GridItemComponent}
        hideAddToCartButton={hideAddToCartButton}
        showFinancing={showFinancing}
        financingText={financingText}
        disableBorder={disableBorder}
      />
    </div>
  );
};

export default CategoryGrid;
